import { GSEndpoint } from "../models/endpoint";
import { User } from "../models/user";

// Matches GSStats' HintStats.to_dict()/ProjectHintStats.to_dict() output directly - snake_case, not camelCase.
export interface HintStatsSummaryI {
    entities?: string[];
    start_time?: string;
    end_time?: string;

    // numeric fields can come back as numeric strings from the API
    hints_checked_out: number | string;
    hints_completed: number | string;
    hints_timed_out: number | string;
    total_number_of_hints: number | string;
    average_time_per_hint: number | string;

    teh_hints_checked_out: number | string;
    teh_hints_completed: number | string;
    teh_hints_timed_out: number | string;
    teh_people_added: number | string;

    oqh_hints_checked_out: number | string;
    oqh_hints_completed: number | string;
    oqh_hints_timed_out: number | string;
    oqh_people_added: number | string;

    // only tracked for projects
    bad_hints_removed?: number | string;
    stale_hints_removed?: number | string;
    hints_queued?: number | string;
    processed_by_pipeline?: number | string;
    hints_added_by_pipeline?: number | string;
    hints_completed_by_pipeline?: number | string;
}

export interface StatsSummaryI {
    id: string;
    allTime: HintStatsSummaryI;
    lastWeek: HintStatsSummaryI;
}

export class GetStatsSummary extends GSEndpoint<{}, StatsSummaryI> {
    /**
     * Gets the all-time and last-week stats summary (from the statssummary table) for a user, group, or app.
     *
     * @param id the id of the entity to get the stats summary for
     */
    constructor(id: string) {
        super("stats/summary/{id}", "GET", [], undefined, [id]);
    }

    override async request(user: Partial<User>): Promise<StatsSummaryI> {
        return (await super.makeRequest({}, user)) as StatsSummaryI;
    }
}

export class GetSelfStatsSummary extends GSEndpoint<{}, StatsSummaryI> {
    constructor() {
        super("stats/self", "GET", []);
    }

    override async request(user: Partial<User>): Promise<StatsSummaryI> {
        return (await super.makeRequest({}, user)) as StatsSummaryI;
    }
}
